/*
    User bubble
*/

// Fill Color Selector
var select = document.getElementById('chat-bubble-user-color-selector');
var colorPreview = document.getElementById('color-preview-chat-bubble-user');

window.updateUserBubbleColor = function () {
    select.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";
        
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}
select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {

            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle[".regular-message.user"]["background"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        console.log("NO COLOR");
        colorPreview.style.backgroundColor = "transparent !important";
        console.log(colorPreview);
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['.regular-message.user']['background'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        console.log("COLOR");
        colorPreview.style.border = "transparent !important";
    }
})

// Text Color Selector
var selectText = document.getElementById('chat-bubble-user-text-color-selector');
var colorPreviewText = document.getElementById('color-text-preview-chat-bubble-user');
window.updateUserBubbleTextColor = function () {
    selectText.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectText.appendChild(option);

    colorPreviewText.style.backgroundColor = "transparent";
    colorPreviewText.style.border = "#5D5D5D 1px solid";

    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectText.appendChild(option);
    }
}
selectText.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewText.style.backgroundColor = val.settings.color;
            window.customStyle[".regular-message.user"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewText.style.backgroundColor = "transparent !important";
        colorPreviewText.style.border = "#5D5D5D 1px solid";
        window.customStyle['.regular-message.user']['color'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewText.style.border = "transparent !important";
    }
})

// Font Style
var selectFont = document.getElementById("chat-bubble-user-font");
window.updateUserBubbleFonts = function() {
    selectFont.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFont.appendChild(option);

    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFont.appendChild(option);
    }
}
selectFont.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFont.style.color = val.settings.color;
            selectFont.style.fontFamily = val.settings.fontFamily;
            selectFont.style.fontSize = val.settings.size;

            window.customStyle[".regular-message.user"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".regular-message.user"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".regular-message.user"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
})

// Corner Radius
var cornerRadiusTopL = document.getElementById('corner-radius-topL-chat-bubble-user');
cornerRadiusTopL.addEventListener('change', function(event) {
    window.customStyle[".regular-message.user"]["border-top-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusTopR = document.getElementById('corner-radius-topR-chat-bubble-user');
cornerRadiusTopR.addEventListener('change', function(event) {
    window.customStyle[".regular-message.user"]["border-top-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomR = document.getElementById('corner-radius-bottomR-chat-bubble-user');
cornerRadiusBottomR.addEventListener('change', function(event) {
    window.customStyle[".regular-message.user"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomL = document.getElementById('corner-radius-bottomL-chat-bubble-user');
cornerRadiusBottomL.addEventListener('change', function(event) {
    window.customStyle[".regular-message.user"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Padding
var paddingTop = document.getElementById('padding-top-chat-bubble-user');
paddingTop.addEventListener('change', function(event){
    window.customStyle[".regular-message.user"]["padding-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingBottom = document.getElementById('padding-bottom-chat-bubble-user');
paddingBottom.addEventListener('change', function(event){
    window.customStyle[".regular-message.user"]["padding-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingLeft = document.getElementById('padding-left-chat-bubble-user');
paddingLeft.addEventListener('change', function(event){
    window.customStyle[".regular-message.user"]["padding-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingRight = document.getElementById('padding-right-chat-bubble-user');
paddingRight.addEventListener('change', function(event){
    window.customStyle[".regular-message.user"]["padding-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Margin
var marginTop = document.getElementById('margin-top-chat-bubble-user');
marginTop.addEventListener('change', function(event){
    window.customStyle[".regular-message.user"]["margin-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginBottom = document.getElementById('margin-bottom-chat-bubble-user');
marginBottom.addEventListener('change', function(event){
    window.customStyle[".regular-message.user"]["margin-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginLeft = document.getElementById('margin-left-chat-bubble-user');
marginLeft.addEventListener('change', function(event){
    window.customStyle[".regular-message.user"]["margin-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginRight = document.getElementById('margin-right-chat-bubble-user');
marginRight.addEventListener('change', function(event){
    window.customStyle[".regular-message.user"]["margin-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Border
var borderColor = "black";
var borderWidth = "1px";
var borderString = borderWidth + " solid " + borderColor;

var selectBorderPos = document.getElementById('chat-bubble-user-border-selector');
selectBorderPos.addEventListener('change', function(event) {
    if (event.target.value == "inside") {
        window.customStyle[".regular-message.user"]["box-sizing"] = "border-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        window.customStyle[".regular-message.user"]["box-sizing"] = "content-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
})

var selectBorder = document.getElementById('chat-bubble-user-border-color-selector');
var colorPreviewBorder = document.getElementById('color-border-preview-chat-bubble-user');
window.updateUserBubbleBorderColor = function() {
    selectBorder.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectBorder.appendChild(option);

    colorPreviewBorder.style.backgroundColor = "transparent";
    colorPreviewBorder.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectBorder.appendChild(option);
    }
}
selectBorder.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {

            colorPreviewBorder.style.backgroundColor = val.settings.color;

            borderColor = val.settings.color;
            borderString = borderWidth + " solid " + borderColor;
            window.customStyle[".regular-message.user"]["border"] = borderString + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewBorder.style.backgroundColor = "transparent";
        colorPreviewBorder.style.border = "#5D5D5D 1px solid";
        window.customStyle['.regular-message.user']['background-color'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewBorder.style.border = "transparent";
    }
});

var widthBorder = document.getElementById('width-border-chat-bubble-user');
widthBorder.addEventListener('change', function(event) {
    borderWidth = event.target.value;
    borderString = borderWidth + " solid " + borderColor;
    window.customStyle[".regular-message.user"]["border"] = borderString + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Shadow
var hOffset = "0px";
var vOffset = "0px";
var blurShadow = "0px";
var spreed = "0px";
var shadowColor = "#000";
var shadowPos = "";

var hOffsetElement = document.getElementById("chat-bubble-user-shadow-h-offset");
hOffsetElement.addEventListener("change", function(event) {

    hOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.user"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var vOffsetElement = document.getElementById("chat-bubble-user-shadow-v-offset");
vOffsetElement.addEventListener("change", function(event) {

    vOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.user"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var blurElement = document.getElementById("chat-bubble-user-shadow-blur");
blurElement.addEventListener("change", function(event) {

    blurShadow = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.user"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var spreedElement = document.getElementById("chat-bubble-user-shadow-spreed");
spreedElement.addEventListener("change", function(event) {

    spreed = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.user"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var selectShadow = document.getElementById('chat-bubble-user-shadow-color-selector');
var colorPreviewShadow = document.getElementById('color-shadow-preview-color-chat-bubble-user');
window.updateUserBubbleShadowColor = function() {
    selectShadow.replaceChildren();
    
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectShadow.appendChild(option);

    colorPreviewShadow.style.backgroundColor = "transparent";
    colorPreviewShadow.style.border = "#5D5D5D 1px solid";
        
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectShadow.appendChild(option);
    }
}
selectShadow.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {

            colorPreviewShadow.style.backgroundColor = val.settings.color;

            shadowColor = val.settings.color;
            var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";
            window.customStyle[".regular-message.user"]["box-shadow"] = shadow;
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewShadow.style.backgroundColor = "transparent";
        colorPreviewShadow.style.border = "#5D5D5D 1px solid";
        window.customStyle['.regular-message.user']['box-shadow'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent";
    }
});

var shadowPosElement = document.getElementById("chat-bubble-user-shadow-position");
shadowPosElement.addEventListener("change", function(event) {
    if (event.target.value == "inner") {
        shadowPos = "inset";
    } else {
        shadowPos = "";
    }
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".regular-message.user"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})